export default {
  getFilters: state => state.filters,
  getOverview: state => state.overview,
  getCurrencyCode: state => state.overview?.currency_code ?? 'BRL',
  getKpis: state => state.overview?.kpis ?? null,
  getTrend: state => state.overview?.trend ?? [],
  getLastSync: state => state.overview?.last_sync ?? null,
  getFunnel: state => state.funnel,
  getRankings: state => state.rankings,
  getDistribution: state => state.distribution,
  getSyncStatus: state => state.syncStatus,
  isLoadingOverview: state => state.uiFlags.isLoadingOverview,
  isLoadingFunnel: state => state.uiFlags.isLoadingFunnel,
  isLoadingRankings: state => state.uiFlags.isLoadingRankings,
};
